import {
    Accordion,
    Button,
    Card,
    Col,
    Container,
    Form,
    NavbarCollapse,
    Row,
    Toast,
} from "react-bootstrap";
import { faCaretDown, faCaretUp, faEye, faPen, faPrint } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcons } from "@dcam/dcam_flhealth_component_library";
import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { apiConfig } from "../../authConfig";
import apiClient from "../../client/ApiGetClient";
import useData from "../../hooks/useData";
import usePostData from "../../hooks/usePostData";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Console } from "console";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import {
    CaseReportFormRequest,
    ClientSearchResult,
    ClientUpdateRequest,
    DiagnosisDetail,
    SearchInfoRequest,
    SearchLabRequest,
    SelectOption,
} from "../../types";

import usePost from "../../hooks/usePost";
import useGetData from "../../hooks/useGetData";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
//import ".ProviderDashboard/ProviderDashboard.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { set } from "date-fns";
import EditUser from "../UserManagement/EditUser";
import { useNavigate } from "react-router-dom";
import "./FacilityUserReview.scss";
import { faMemoCircleCheck } from "@fortawesome/pro-regular-svg-icons";


const FacilityUserDashboard: React.FC = () => {

    const { instance, accounts } = useMsal();
    
    const account = accounts[0];
    const [isUserFormEnable, setUserFormEnable] = useState(false);
    const [email, setUserEmail] = useState("");
    const navigate = useNavigate();

    const clickHandler= (row:any) => {
            setUserFormEnable(true);
            setUserEmail(row.email);
           /// console.log(row);
    }

    const UserColumn = [
        {
            name: <b>Facility ID</b>, // Routinized Hospital Id
            selector: (row: any) => row.routinizedHospitalId,
            sortable: true,
            width: "140px",
        },
        {
            name: <b>Facility Name</b>,
            selector: (row: any) => row.routinizedHospitalName,
            sortable: true,
            width: "280px",
        },
        // {
        //     name: <b>Facility Type</b>,
        //     selector: (row: any) => row.hospitalTypeId,
        //     width: "280px",
        // },
        {
            name: <b>Address</b>,
            selector: (row: any) => row.address? `${row.address}, ${row.city}` : "-",
            width: "280px",
        },
        // {
        //     name: <b>Status</b>,
        //     selector: (row: any) => {
        //         if (row.IsApproved == null) return "Pending";
        //         if (row.IsApproved == 0) return "Rejected";
        //         if (row.IsApproved == 1) return "Approved";
        //         return "Unknown"; // Optional: in case IsApproved has unexpected values
        //     },
        //     width: "100px",
        // },
        // {
        //     name: <b>Request Submitted By</b>,
        //     selector: (row: any) => row.userFirstName + " " + row.userLastName,
        //     sortable: true,
        //     width: "250px",
        // },
        {
            name: <b>Date Created</b>,
            selector: (row: any) => {
                const date = new Date(row.dateCreated);
                return date.toLocaleString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true, // For AM/PM format
                });
              },
            width: "180px",
        },
        
       
        {
                    name: <b style={{ display: "block", textAlign: "center", width: "100%" }}>Action</b>,
                    selector: (row: any) => 
                        <div>
                            {row.isApproved == null && (
                                <div>
                            <AppButton
                                variant={"secondary"}
                                onClick={() => navigate('/Facility/view/'+row?.routinizedHospitalId)}
                            >
                                <FontAwesomeIcon icon={faEye}/> &nbsp;
                                View
                            </AppButton>
                            &nbsp;
                            <AppButton variant="primary"
                                onClick={() => navigate('/Facility/Edit/'+row?.routinizedHospitalId)}
                            >
                                <FontAwesomeIcon icon={faPen} /> Edit
                            </AppButton>
                            </div>
                            )}
                        </div>,
                    width: "220px",
                },
    ];

    const [userData, setUserData] = useState<any>();

    const [hospitalData, setHospitalData] = useState<any>();

    const { getDataById: getAllUserSecurity } = useGetData<any, string>(
        "Client/GetAllRoutinizedHospitals",
        "GET"
      );

    //   const { getDataById: getAllHospitalRegistrations } = useGetData<any, string>(
    //     "HospitalRegistration/GetAllHospitalRegistrations",
    //     "GET"
    //   );

      const { getDataById: getAllClients } = useGetData<any, string>(
        "Client/GetAllClients",
        "GET"
      );

      const { getDataById: getUserId } = useGetData<any, string>(
        "UserSecurity/GetUserSecurityByEmail/"+account.username,
        "GET"
      );

      useEffect(() => {
        const loadData = async () => {
          const data = await getAllUserSecurity("");
          setUserData(data)
          if(data){
            const userData = await getUserId("");
            if(userData?.user?.isActive) {
                if(userData?.user?.roleName!="Admin"){
                    if(userData){
                        let filterData=data?.filter((x: { routinizedHospitalId: any; })=>x.routinizedHospitalId==userData?.user?.routinizedHospitalId);
                        setUserData(filterData)
                    }
                }
                if (userData?.user?.roleName === "Staff" ) {
                    navigate("/dashboard");
                }
            } else {
                navigate('/unauthorized');
            }
          }
        };
        loadData();     
      }, []);

      

    const handleBackButton= () => {
        setUserFormEnable (false)
    }
    
   // const [clientData, setClientData] = useState<any>([]);
    const [filteredData, setFilteredData] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [roleName, setRoleName] = useState<string>("");


  const handleSearch = (searchValue: string) => {
    setSearchTerm(searchValue);
    const lowercasedValue = searchValue.toLowerCase();
    searchValue = searchValue.toLowerCase();
    if (!searchValue) {
        setFilteredData(userData);
      return;
    }
    
    const filtered = userData?.filter((row: any) => {
        const isActiveText = row?.isActive ? "Active" : "Inactive";
    
        return (
            row?.hospitalName?.toLowerCase().search(searchValue) >= 0 
            //||
            // row?.lastName?.toLowerCase().search(searchValue) >= 0 ||
            // row?.email?.toLowerCase().search(searchValue) >= 0 ||
            // row?.roleName?.toLowerCase().search(searchValue) >= 0 ||
            // row?.routinizedHospitalName?.toLowerCase().search(searchValue) >= 0 ||
            // isActiveText.toLowerCase().search(searchValue) >= 0
        );
    });

    setFilteredData(filtered);
   };

  useEffect(() => {
    const loadData = async () => {
        const data = await getAllUserSecurity("");
        setUserData(data);
        if (data) {
             // Set the original data
            setFilteredData(data); // Initialize the filtered data to show all rows initially
            const userData = await getUserId("");
            if (userData?.user?.roleName) {
                setRoleName(userData.user.roleName);
              }
            if (userData?.user?.roleName !== "Admin") {
                const filterData = data.filter(
                    (x: { routinizedHospitalId: any }) =>
                        x.routinizedHospitalId === userData?.user?.routinizedHospitalId
                );
                setUserData(filterData);
                setFilteredData(filterData);
            }
        }
    };
    loadData();
   }, []);
    return (
    <>
    <Container>
       {/* {!isUserFormEnable?  */}
        <div className="full-screen-container">
            
            {/* <AppCard title="Florida Heath Care Lookup Dashboard"> */}
                
                <Row className="mb-3">
                    <Col>
                        <br></br>
                        <AppCard title="Facility Dashboard (Approved Facilities)" bottomMargin>
                            <Row>
                                <Col >
                                    <AppDataTable
                                        columns={UserColumn}
                                        data={filteredData}
                                        pagination={true}
                                        search={true}
                                        searchCallBack={handleSearch}
                                        //loading={isProgress}
                                        noDataComponent={undefined}
                                    />
                                </Col>
                            </Row>
                        </AppCard>
                    </Col>
                </Row>
            {/* </AppCard> */}
        </div>
        {/* :
        <EditUser email={email} onClick={handleBackButton}></EditUser>} */}
        
        </Container>
        </>
    );
};

export default FacilityUserDashboard;